import { Link } from 'react-router';

const SIZES = {
  sm: { mark: 'h-6', word: 'text-xl' },
  md: { mark: 'h-8', word: 'text-[1.7rem]' },
  lg: { mark: 'h-14', word: 'text-5xl' },
} as const;

/** The MOGZO lockup: mascot mark plus the Fredoka Bold wordmark (Figma 1:9). */
export function Logo({
  size = 'md',
  tone = 'ink',
  linked = true,
}: {
  size?: keyof typeof SIZES;
  tone?: 'ink' | 'cream';
  linked?: boolean;
}) {
  const content = (
    <span className="inline-flex items-center gap-2">
      <img src="/brand/mascot.svg" alt="" className={`${SIZES[size].mark} w-auto`} />
      <span
        className={`font-display font-bold leading-none tracking-tight ${SIZES[size].word} ${tone === 'cream' ? 'text-cream' : 'text-ink'}`}
      >
        mogzo
      </span>
    </span>
  );
  if (!linked) return content;
  return (
    <Link to="/" aria-label="MOGZO home" className="inline-flex rounded-lg">
      {content}
    </Link>
  );
}
